import { FeatureFlags, FeatureFlagsEnum } from '@models/featureflags.model';

export interface FeatureflagsStateModel {
  featureFlags: FeatureFlags;
  loading: boolean;
  loaded: boolean;
  savingKey: string | null;
}

const createInitialFeatureFlags = (): Record<FeatureFlagsEnum, boolean> =>
  Object.values(FeatureFlagsEnum).reduce(
    (acc, key) => ({ ...acc, [key]: false }),
    {} as Record<FeatureFlagsEnum, boolean>
  );

export const FeatureflagsInitialState: FeatureflagsStateModel = {
  featureFlags: createInitialFeatureFlags(),
  loading: false,
  loaded: false,
  savingKey: null,
};
